let swRegistration: ServiceWorkerRegistration | null = null

export function setAppUpdateRegistration(registration: ServiceWorkerRegistration) {
  swRegistration = registration
}

/**
 * Força uma checagem imediata por uma versão nova do Service Worker.
 * Além do polling do `useAppUpdater`, o `httpClient` chama isso quando a API
 * responde com um `X-App-Version` diferente do último visto — assim a
 * checagem não fica presa ao intervalo fixo quando já se sabe que saiu deploy.
 */
export function checkForAppUpdate() {
  swRegistration?.update()
}
